export default __webpack_public_path__ + "15cd85e47328e7571f8fc6434acfb269.svg";